import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Output, inject } from '@angular/core';

@Directive({
  selector: '[vbDragDropFileUpload]',
  standalone: false  //NOSONAR
})
export class DragDropFileUploadDirective {
  private el = inject(ElementRef);

  @Output() fileDropped = new EventEmitter<any>();

  @HostBinding('style.background-color') private background = '#ffffff';
  @HostBinding('style.height') private height = '100%';

  constructor() {
    const el = this.el;

    this.height = `${($(el.nativeElement)?.parents('.card-body')?.height() ?? 100) - 100}px`;
  }

  // Dragover Event
  @HostListener('dragover', ['$event']) dragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.background = '#e2eefd';
    this.applyActiveStyles();
  }

  // Dragleave Event
  @HostListener('dragleave', ['$event']) public dragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.background = '#ffffff';
    this.applyInactiveStyles();
  }

  // Drop Event
  @HostListener('drop', ['$event']) public drop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.background = '#ffffff';

    const files = event.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
    this.applyInactiveStyles();
  }

  applyActiveStyles() {
    this.el.nativeElement.classList.add('active');
    this.el.nativeElement.style.display = 'flex';
    this.el.nativeElement.style.alignItems = 'center';
    this.el.nativeElement.style.justifyContent = 'center';
  }

  applyInactiveStyles() {
    this.el.nativeElement.classList.remove('active');
    this.el.nativeElement.style.display = 'block';
    this.el.nativeElement.style.alignItems = 'center';
    this.el.nativeElement.style.justifyContent = 'center';
  }
}
